import { render, staticRenderFns } from "./TimeCom.vue?vue&type=template&id=1546c6d0&scoped=true"
import script from "./TimeCom.vue?vue&type=script&lang=js"
export * from "./TimeCom.vue?vue&type=script&lang=js"
import style0 from "./TimeCom.vue?vue&type=style&index=0&id=1546c6d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546c6d0",
  null
  
)

export default component.exports